import React, { useEffect, useState } from "react";
import * as Icons from "lucide-react";
import api from "@/lib/api";
import PageHeader from "@/components/common/PageHeader";
import GlassCard from "@/components/common/GlassCard";
import { Input } from "@/components/ui/input";

const actionColors = {
  create: "text-[#6EE7B7]", update: "text-[#FCD34D]",
  delete: "text-[#FCA5A5]", login: "text-[#93C5FD]",
  logout: "text-white/60", view: "text-white/60",
};

export default function ActivityLogs() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [resource, setResource] = useState("");

  const load = async () => {
    const params = {};
    if (q) params.q = q;
    if (resource) params.resource = resource;
    const { data } = await api.get("/activity", { params });
    setItems(data.items || []);
  };
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [q, resource]); // eslint-disable-line

  return (
    <div>
      <PageHeader
        title="Activity Logs"
        subtitle="Complete audit trail across all modules and users."
      />

      <div className="flex items-center gap-3 mb-4">
        <div className="relative flex-1 max-w-md">
          <Icons.Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search logs…"
            className="pl-9 bg-black/20 border-white/10 text-white placeholder:text-white/30" />
        </div>
        <div className="flex items-center gap-1">
          {["", "auth", "users", "services", "portfolio", "blog", "leads", "media"].map(r => (
            <button key={r || "all"} onClick={() => setResource(r)}
              className={`h-9 px-3 rounded-lg text-xs border transition-colors capitalize ${resource === r ? "bg-white/10 border-white/20 text-white" : "border-white/10 text-white/60 hover:text-white"}`}>
              {r || "All"}
            </button>
          ))}
        </div>
      </div>

      <GlassCard className="p-0">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[11px] uppercase tracking-wider text-white/45 bg-white/[0.02]">
              <th className="px-5 py-3 font-medium">When</th>
              <th className="px-5 py-3 font-medium">User</th>
              <th className="px-5 py-3 font-medium">Action</th>
              <th className="px-5 py-3 font-medium">Resource</th>
              <th className="px-5 py-3 font-medium">IP</th>
            </tr>
          </thead>
          <tbody>
            {items.map((r) => (
              <tr key={r.id} className="border-t border-white/5 hover:bg-white/[0.02]">
                <td className="px-5 py-3 text-white/60 text-xs">{r.timestamp ? new Date(r.timestamp).toLocaleString() : "—"}</td>
                <td className="px-5 py-3 text-white">{r.user_name || r.user_email || "System"}</td>
                <td className={`px-5 py-3 font-medium capitalize ${actionColors[r.action] || "text-white/80"}`}>{r.action}</td>
                <td className="px-5 py-3 text-white/70 font-mono text-xs">{r.resource}{r.resource_id ? ` / ${r.resource_id.slice(-6)}` : ""}</td>
                <td className="px-5 py-3 text-white/50 font-mono text-xs">{r.ip_address || "—"}</td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={5} className="px-5 py-12 text-center text-white/40">No logs match your filters.</td></tr>
            )}
          </tbody>
        </table>
      </GlassCard>
    </div>
  );
}
